"use client";

import { useTranslations } from "next-intl";

interface AuthSocialProofProps {
  className?: string;
  textClassName?: string;
  countClassName?: string;
  avatarContainerClassName?: string;
  avatarClassName?: string;
  overlapClassName?: string;
  text?: string;
}

export function AuthSocialProof({
  className = "",
  textClassName = "text-[12.5px] leading-[1.45] text-(--mk-cream-75)",
  text = "",
}: AuthSocialProofProps) {
  const t = useTranslations("Auth");
  return (
    <p className={`${className} ${textClassName}`.trim()}>
      {text || t("socialProof")}
    </p>
  );
}
